// src/telemetry/TelemetryRegistry.ts

import { TELEMETRY_ROUTES } from './constants/routes';
import { MODULES } from './constants/modules';

const DASHBOARD_SECTIONS: Record<string, string> = {
  'strategy-dashboard': 'Strategy Overview',
  'keyword-planner': 'Keyword Planner',
  'as-is-state': 'AS-IS State',
  'goal-setting': 'Goal Setting',
  'action-plan': 'Action Plan',
  'implementation-overview': 'Implementation Overview',
  'blog': 'Blog Generator',
  'faq': 'FAQ Generator',
  'governance-overview': 'Governance Overview',
  'as-is-performance': 'AS-IS Performance',
  'goals-tracking': 'Goal Tracking',
  'action-plan-tracking': 'Action Plan Tracking',
  'competitor-benchmark': 'Competitor Benchmark',
  'optimization-overview': 'Optimization Overview',
  'ecosystem-monitor': 'Ecosystem Monitor',
  'foresight-recommends': 'Foresight Recommends',
  'insight-navigator': 'Insight Navigator',
  'alerts': 'Alerts',
  'classified-ads': 'Implementation / Classified Ads',
  'image-submission': 'Implementation / Image Submission',
  'pdf-submission': 'Implementation / PDF Submission',
  'off-page': 'Off-Page SEO',
  'on-page': 'On-Page SEO',
};

const PROFILE_TABS: Record<string, string> = {
  'contact': 'Contact & Identity',
  'business': 'Business Details',
  'subscription': 'Subscription & Billing',
  'help': 'Help & Support',
};

const CONTENT_MANAGER_ROUTES: Record<string, string> = {
  '/content-manager': 'Strategy',
  '/content-manager/': 'Strategy',
  '/content-manager/implementation': 'Implementation',
  '/content-manager/governance': 'Governance',
  '/content-manager/optimization': 'Optimization',
};

export class TelemetryRegistry {
  static resolve (pathname: string, search = '', hash = '') {
    let cleanPath = pathname;
    const base = import.meta.env.BASE_URL || '/';
    if (base !== '/' && cleanPath.startsWith(base)) {
      cleanPath = cleanPath.substring(base.length);
    }
    if (!cleanPath.startsWith('/')) {
      cleanPath = '/' + cleanPath;
    }
    const normalized = cleanPath !== '/' ? cleanPath.replace(/\/+$/, '') : cleanPath;

    // 1. Dashboard Tab Resolution
    if (normalized === '/dashboard') {
      const section = hash.replace(/^#/, '');
      return {
        module: MODULES.SEO_MANAGER,
        submodule: DASHBOARD_SECTIONS[section] || 'Strategy Overview'
      };
    }

    // 2. Profile Tab Resolution
    if (normalized === '/profile') {
      const tab = new URLSearchParams(search).get('tab') || 'contact';
      return {
        module: MODULES.PROFILE,
        submodule: PROFILE_TABS[tab] || 'Contact & Identity'
      };
    }

    // 3. Content Manager Sub-route Resolution
    if (normalized.startsWith('/content-manager')) {
      const matchedRoute = Object.keys(CONTENT_MANAGER_ROUTES)
        .filter(route => normalized.startsWith(route))
        .sort((a, b) => b.length - a.length)[0];

      return {
        module: MODULES.CONTENT_MANAGER,
        submodule: matchedRoute ? CONTENT_MANAGER_ROUTES[matchedRoute] : 'Strategy'
      };
    }

    // 4. Default Telemetry Routes Lookup
    const route = TELEMETRY_ROUTES[normalized as keyof typeof TELEMETRY_ROUTES];
    if (route) {
      return route;
    }

    // 5. Fallback (use 'Dashboard' as safe default to prevent Pydantic validation errors)
    return {
      module: MODULES.DASHBOARD,
      submodule: 'Unknown Page'
    };
  }
}
